import React, { useContext } from "react";
import { SelectedCardContext } from "../../Context/SelectedCardContext";

import styles from "./About.module.css";
import arrowleft from "../../Assests/icons/left-blue-arrow.svg";
import arrowright from "../../Assests/icons/right-blue-arrow.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import industryExpertise1 from "../../Assests/Images/servicesbg1.jpeg";
import industryExpertise2 from "../../Assests/Images/servicesbg2.jpeg";
import industryExpertise3 from "../../Assests/Images/servicesbg3.jpeg";
import industryExpertise4 from "../../Assests/Images/servicesbg4.jpg";
import industryExpertise5 from "../../Assests/Images/servicesbg5.jpeg";
import industryExpertise6 from "../../Assests/Images/servicesbg6.jpg";
import industryExpertise7 from "../../Assests/Images/servicesbg7.jpg";
import industryExpertise8 from "../../Assests/Images/servicesbg8.jpg";
import industryExpertise9 from "../../Assests/Images/servicesbg9.jpg";
import arrow from "../../Assests/Images/purple Arrow.svg";



const industryExpertiseData = [
  {
    title: "Oil & Gas",
    description:
      "Cost-effective sourcing and logistics support for high-value energy operations.",
    image: industryExpertise1,
  },
  {
    title: "Mining",
    description:
      "Reliable supply chains built for harsh conditions and remote mining environments.",
    image: industryExpertise2,
  },
  {
    title: "Manufacturing & Industrial Plants ",
    description:
      "Scalable sourcing for uninterrupted production and smooth operational continuity.",
    image: industryExpertise3,
  },
  {
    title: "International Aid & Humanitarian Relief ",
    description:
      "Fast, compliant delivery of essential supplies for humanitarian missions.",
    image: industryExpertise4,
  },
  {
    title: "Utility & Energy ",
    description:
      "Trusted procurement for power, water, and renewable energy infrastructure.",
    image: industryExpertise5,
  },
  {
    title: "Pharmaceuticals ",
    description:
      "Compliant sourcing for cleanroom, lab, and pharmaceutical production environments.",
    image: industryExpertise6,
  },
  {
    title: "Marine & Offshore",
    description:
      "Durable systems and safety gear for vessels and offshore platforms.",
    image: industryExpertise7,
  },
  {
    title: "Healthcare ",
    description:
      "End-to-end procurement for hospitals, clinics, and healthcare responders.",
    image: industryExpertise8,
  },
  {
    title: "Petroleum (Refining & Retail) ",
    description:
      "Mission-critical supply for downstream petroleum operations and fuel networks.",
    image: industryExpertise9,
  },
];



const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1280 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1280, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

const arrowStyle = {
  background: "transparent",
  border: 0,
  color: "#000",
  fontSize: "80px",
};

const CustomRight = ({ onClick }) => (
  <button className={styles.arrowright} onClick={onClick} style={arrowStyle}>
    <img src={arrowright} alt="next" style={{ width: 18 }} />
  </button>
);

const CustomLeft = ({ onClick }) => (
  <button className={styles.arrowleft} onClick={onClick} style={arrowStyle}>
    <img src={arrowleft} alt="previous" style={{ width: 18 }} />
  </button>
);

const IndustryExpertise = () => {
  const { selectedCard, setSelectedCard } = useContext(SelectedCardContext);

  const handleCardClick = (item) => {
    setSelectedCard(item);
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
  };

  return (
    <div className={styles.industryExpertiseSection}>
      
        <section className={styles.expertiseSection}>
          {!selectedCard && (<div className={styles.expertiseHeader}>
            <div className={styles.expertiseHeading}>Industry Expertise</div>
            <div className={styles.expertiseDetailData}>
              Our team brings deep industry knowledge across critical global
              sectors, ensuring precision, compliance, and efficiency in every
              transaction.
            </div>
          </div>
          )}

          <Carousel
            responsive={responsive}
              autoPlay
            swipeable
            draggable
            infinite
            keyBoardControl
            stagePadding={{ left: 5, right: 5 }}
            className={styles.expertiseCarouselList}
            arrows
            partialVisible={false}
            itemClass={styles.expertiseCarouselItem}
            customRightArrow={<CustomRight />}
            customLeftArrow={<CustomLeft />}
          >
            {industryExpertiseData.map((item, index) => (
              <div
                key={index}
                className={styles.expertiseItem}
              
              >
                <div className={styles.expertiseImageWrapper}>
                <img src={item.image} alt={item.title} className={styles.expertiseImage} />
                </div>
               
                <div className={styles.expertiseTextContent}>
                  <h3 className={styles.expertiseTitle}>{item.title}</h3>
                  <p className={styles.expertiseDescription}>
                    {item.description}
                  </p>
                  {/* <button className={styles.readMoreButton} onClick={() => handleCardClick(item)}>Read More</button> */}
                    <div className={styles.readMoreContainer} onClick={() => handleCardClick(item)}>
                    <img src={arrow} className={styles.arrowIcon} alt="Arrow icon" />
                    <span className={styles.readmore}>Read More</span>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </section>
    </div>
  );
};

export default IndustryExpertise;
